export const route = {
  home: "/",
  login: "/",
  dashboard: "/dashboard",
  items: "/items",
  itemCreate: "/items/create",
  itemEdit: "/items/edit/:id",
  materials: "/materials",
  categories: "/categories",
  parties: "/parties",
  partyDetail: "/parties/:id",
  partyRates: "/parties/:id/rates",
  payments: "/payments/:id",
  materialOrders: "/materials/orders",
  materialOrderCreate: "/materials/orders/create",
  materialOrderEdit: "/materials/orders/edit/:id",
  materialOrderDetail: "/materials/orders/:id",
  materialPurchases: "/materials/purchases",
  materialPurchaseCreate: "/materials/purchases/create",
  materialPurchaseEdit: "/materials/purchases/edit/:id",
  materialPurchaseDetail: "/materials/purchases/:id",
  materialStockDetail: "/materials/stock/:id",
  cuttingOrders: "/cutting/orders",
  cuttingOrderCreate: "/cutting/orders/create",
  cuttingOrderEdit: "/cutting/orders/edit/:id",
  cuttingOrderDetail: "/cutting/orders/:id",
  cuttingReceives: "/cutting/receives",
  cuttingReceiveCreate: "/cutting/receives/create",
  cuttingReceiveEdit: "/cutting/receives/edit/:id",
  cuttingReceiveDetail: "/cutting/receives/:id",
  turningOrders: "/turning/orders",
  turningOrderCreate: "/turning/orders/create",
  turningOrderEdit: "/turning/orders/edit/:id",
  turningOrderDetail: "/turning/orders/:id",
  turningReceives: "/turning/receives",
  turningReceiveCreate: "/turning/receives/create",
  turningReceiveEdit: "/turning/receives/edit/:id",
  turningReceiveDetail: "/turning/receives/:id",
  vmcOrders: "/vmc/orders",
  vmcOrderCreate: "/vmc/orders/create",
  vmcOrderEdit: "/vmc/orders/edit/:id",
  vmcOrderDetail: "/vmc/orders/:id",
  vmcReceives: "/vmc/receives",
  vmcReceiveCreate: "/vmc/receives/create",
  vmcReceiveEdit: "/vmc/receives/edit/:id",
  vmcReceiveDetail: "/vmc/receives/:id",
  users: "/users",
  employees: "/employees",
  salaries: "/salaries/:id",
  accounts: "/accounts",
  activityLogs: "/activity-logs",
  businessReport: "/business-report",
  profile: "/profile",
  settings: "/settings",
  forbidden: "/403",
};
